import { render, staticRenderFns } from "./FacturaEmision.vue?vue&type=template&id=21b72616&scoped=true&"
import script from "./FacturaEmision.vue?vue&type=script&lang=js&"
export * from "./FacturaEmision.vue?vue&type=script&lang=js&"
import style0 from "./FacturaEmision.vue?vue&type=style&index=0&id=21b72616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b72616",
  null
  
)

export default component.exports